import clearDateAt from '.'

export default function clearDateAtDays (date, clone = false) {
  return clearDateAt(date, 'day', clone)
}
